import React, { useState } from 'react';
import PropTypes from 'prop-types';
import chevronGreyIcon from 'assets/images/icons/chevron-grey.svg';
import { dashboardFontSizeOptions, dashboardFontWeightOptions } from '../utils';
import { useTranslation } from 'react-i18next';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import DashboardThemeColorPicker from './DashboardThemeColorPicker';

const WidgetStyling = ({ values, handleChange }) => {
  const { t } = useTranslation();
  const [showContent, setShowContent] = useState(true);

  return (
    <>
      <div className='text-and-link hyper-link accordion d-flex flex-column'>
        <div className='accordion-item border-0 px-3 py-2 mb-0'>
          <div className='d-flex justify-content-between align-items-center'>
            <span className='theme-text-black-1 theme-size-1_1 theme-font-inter-medium'>
              {t('text_widget_styling')}
            </span>
            <img
              src={chevronGreyIcon}
              className={`toggle-button cursor-pointer p-2 ${showContent ? '' : 'rotate-180'}`}
              onClick={() => setShowContent((prevState) => !prevState)}
            />
          </div>
        </div>

        <div className='accordion-item border-0 theme-text-grey-1'>
          {showContent && (
            <div className='p-3 border-top-grey-10-h-1 d-flex flex-column gap-3'>
              <div className='d-flex flex-wrap'>
                <div className='col-4'>{t('text_themes')}:</div>
                <div className='col-8'>
                  <div className='d-flex flex-column gap-2'>
                    <div>
                      <label>{t('text_background')}</label>
                      <DashboardThemeColorPicker
                        name={'backgroundColor'}
                        value={values.backgroundColor}
                        handleChange={handleChange}
                      />
                    </div>
                    <div>
                      <label>{t('text_font')}</label>
                      <DashboardThemeColorPicker
                        name={'textColor'}
                        value={values.textColor}
                        handleChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex flex-wrap'>
                <div className='col-4'>{t('field_caption')}:</div>
                <div className='col-8 d-flex gap-3'>
                  <div className='w-100'>
                    <label>{t('field_font_size')}</label>
                    <MultiLevelSelect
                      options={dashboardFontSizeOptions}
                      value={[]}
                      name='captionFontSize'
                      handleChange={(name, value) => handleChange(name, value[0])}
                      classes='theme-font-inter-regular'
                      toggleClasses='px-2 py-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1'
                      toggleComponent={
                        <>
                          <label className='cursor-pointer'>
                            {dashboardFontSizeOptions.children.find(
                              (o) => o.value === values.captionFontSize,
                            )?.displayValue || t('select_select')}
                          </label>
                          <img className='rotate-180' src={chevronGreyIcon} />
                        </>
                      }
                      fullWidth
                    />
                  </div>
                  <div className='w-100'>
                    <label>{t('field_font_type')}</label>
                    <MultiLevelSelect
                      options={dashboardFontWeightOptions}
                      value={[]}
                      name='captionFontWeight'
                      handleChange={(name, value) => handleChange(name, value[0])}
                      classes='theme-font-inter-regular'
                      toggleClasses='px-2 py-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1'
                      toggleComponent={
                        <>
                          <label className='cursor-pointer'>
                            {t(
                              dashboardFontWeightOptions.children.find(
                                (o) => o.value === values.captionFontWeight,
                              )?.displayValue || 'select_select',
                            )}
                          </label>
                          <img className='rotate-180' src={chevronGreyIcon} />
                        </>
                      }
                      fullWidth
                    />
                  </div>
                </div>
              </div>

              {'fontSize' in values && (
                <div className='d-flex flex-wrap'>
                  <div className='col-4'>{t('text_label')}:</div>
                  <div className='col-8 d-flex gap-3'>
                    <div className='w-100'>
                      <label>{t('field_font_size')}</label>
                      <MultiLevelSelect
                        options={dashboardFontSizeOptions}
                        value={[]}
                        name='fontSize'
                        handleChange={(name, value) => handleChange(name, value[0])}
                        classes='theme-font-inter-regular'
                        toggleClasses='px-2 py-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1'
                        toggleComponent={
                          <>
                            <label className='cursor-pointer'>
                              {dashboardFontSizeOptions.children.find(
                                (o) => o.value === values.fontSize,
                              )?.displayValue || t('select_select')}
                            </label>
                            <img className='rotate-180' src={chevronGreyIcon} />
                          </>
                        }
                        fullWidth
                      />
                    </div>
                    <div className='w-100'>
                      <label>{t('field_font_type')}</label>
                      <MultiLevelSelect
                        options={dashboardFontWeightOptions}
                        value={[]}
                        name='fontWeight'
                        handleChange={(name, value) => handleChange(name, value[0])}
                        classes='theme-font-inter-regular'
                        toggleClasses='px-2 py-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1'
                        toggleComponent={
                          <>
                            <label className='cursor-pointer'>
                              {t(
                                dashboardFontWeightOptions.children.find(
                                  (o) => o.value === values.fontWeight,
                                )?.displayValue || 'select_select',
                              )}
                            </label>
                            <img className='rotate-180' src={chevronGreyIcon} />
                          </>
                        }
                        fullWidth
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

WidgetStyling.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default WidgetStyling;
